import { DC_Domain_Models_Products_ProductType, Usages_Reading_MeterSaveRequestModel } from '@monorepo-types/dc';
import { object, lazy, string } from 'yup';


export type FormDeviationReason = {
  deviationReasonCode: Usages_Reading_MeterSaveRequestModel['deviationReasonCode'] | '';
  deviationReasonExplanation: NonNullable<Usages_Reading_MeterSaveRequestModel['deviationReasonExplanation']>;
};

type FormMetersDeviationReasons = Partial<Record<DC_Domain_Models_Products_ProductType, FormDeviationReason>>;

export type FormValues = {
  meters: FormMetersDeviationReasons;
  email: string;
};

export const validationSchema = (hasEmailField: boolean) =>
  lazy(({ meters }: FormValues) =>
    object({
      meters: object(
        Object.entries(meters).reduce(
          (values, [name, value]) => ({
            ...values,
            [name]: object({
              deviationReasonCode: string().when([], {
                is: () => value.deviationReasonCode !== undefined,
                then: schema => schema.required('required'),
                otherwise: schema => schema,
              }),
              deviationReasonExplanation: string().when('deviationReasonCode', {
                is: 'ANDERS',
                then: schema => schema.trim().required('required'),
                otherwise: schema => schema.nullable(),
              }),
            }),
          }),
          {},
        ),
      ).required(),
      email: string().when([], {
        is: () => hasEmailField,
        then: schema => schema.email('validation'),
        otherwise: schema => schema.nullable(),
      }),
    }),
  );
